module.exports = "/virtual-football/img/btn-background-black.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/btn-background-black.png
// module id = 280
// module chunks = 6